import { RouterItem } from '@/utils/interfaces';
import HomeLayout from '@/layouts/admin/HomeLayout.vue';

/** 用户个人功能 */
const routesMap: RouterItem[] = [
  {
    path: '/home',
    // redirect: '/user/changePassword',
    component: HomeLayout,
    // meta: { title: '用户中心', icon: 'user' },
    children: [
      {
        path: '',
        name: 'home',
        component: () => import(/* webpackChunkName: "common" */ '@/views/Home.vue'),
        meta: { title: '首页', icon: 'home' },
      },
    ],
  },
];

export default routesMap;
